import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
import { Option } from 'owa-options-core';
import * as React from 'react';
import {
    discardSpamOption,
    isSpamOptionDirty,
    saveSpamOption,
    SpamOptionFull,
    SpamScenarioId,
} from 'owa-spam-row-option';

const SafeSendersDomainsOptionV2: Option = {
    key: 'safeSendersDomainsV2',
    titleStringKey: 'optionTitle_safeSendersDomains',
    searchTermsStringKey: 'optionSearchTerms_safeSendersDomains',
    fullOptionFormSettings: {
        render: () => <SpamOptionFull scenarioId={SpamScenarioId.SafeSendersAndDomains} />,
        isDirty: () => isSpamOptionDirty(SpamScenarioId.SafeSendersAndDomains),
        onSave: () => saveSpamOption(SpamScenarioId.SafeSendersAndDomains),
        onDiscard: () => discardSpamOption(SpamScenarioId.SafeSendersAndDomains),
    },
    isHidden: () => {
        return !isFeatureEnabled('tri-spamV2SenderDomain') || IsShadowMailboxUser();
    },
};

export default SafeSendersDomainsOptionV2;
